export const initialState = {
    refresh: false,
    lastApplicationRecord:[]
};

const applicationReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REFRESH_APPLICATIONS_TABLE":
            return {
                ...state,
                refresh: action.refresh,
                lastApplicationRecord: action.lastApplicationRecord
            }
        default: return state;
    }
}

export default applicationReducer;